import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes=[
  {path:'/',component:()=>import('../views/Home.vue')},
  {path:'/products',component:()=>import('../views/Products.vue')},
  {path:'/products/:code',component:()=>import('../views/ProductDetail.vue')},
  {path:'/cart',component:()=>import('../views/Cart.vue')},
  {path:'/payment/:id',component:()=>import('../views/Payment.vue')},
  {path:'/auth',component:()=>import('../views/Auth.vue')},
  {path:'/orders',component:()=>import('../views/Orders.vue')},
  {path:'/orders/:id',component:()=>import('../views/OrderDetail.vue')},
  {path:'/profile',component:()=>import('../views/Profile.vue')},
]
export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    return to.hash ? { selector: to.hash, offset: { x: 0, y: 0 } } : { x: 0, y: 0 }
  }
})
